import { render } from "./CardNewsroomItem.vue?vue&type=template&id=5ec4f201"
import script from "./CardNewsroomItem.vue?vue&type=script&lang=js"
export * from "./CardNewsroomItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__